<template>
  <v-list-item light link three-line @click="openTopic">
    <v-list-item-avatar>
      <v-avatar>
        <img :src="this.$contentServ + item.cover.formats.thumbnail.url">
      </v-avatar>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title>
        {{ item.title }}
      </v-list-item-title>
      <v-list-item-subtitle>
        {{ item.description }}
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'Item',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    openTopic () {
      this.$store.commit({
        type: 'seeTopic',
        topic: this.item
      })
      this.$router.push({
        name: 'Some topic',
        params: {
          id: this.item.id
        }
      })
    }
  },
  data () {
    return {
      cover: ''
    }
  }
}
</script>

<style scoped>

</style>
